import * as Yup from 'yup'

export const EmailAddresses = Yup.object().shape({
    email_address: Yup
        .string()
        .email('Invalid email')
        .label('Email Address')
        .required(),
    id: Yup.number().required()
}).required()


export const AdminEmailBlacklistManagementSchema =
    Yup.object().shape({
        email_addresses: Yup.array().of(EmailAddresses)
    }).required()


export const AdminEmailDevManagementSchema =
    Yup.object().shape({
        email_address: Yup.string()
            .email('Invalid email')
            .label('Email Address')
            .nullable()
    })
